var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYotiIconHeadwearLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "50px",
    height: "38px",
    viewBox: "0 0 50 38",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon_headwear@2x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "square"
  }, /*#__PURE__*/React.createElement("g", {
    id: "age-scan->-user-experience",
    transform: "translate(-691.000000, -2729.000000)",
    stroke: "#FFFFFF",
    strokeWidth: 2.4966443
  }, /*#__PURE__*/React.createElement("g", {
    id: "page-content",
    transform: "translate(352.000000, 537.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "guidance",
    transform: "translate(9.000000, 2016.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "guidance-example",
    transform: "translate(159.000000, 172.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(135.000000, 6.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon_headwear",
    transform: "translate(37.500000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.837745,30.7311946 C14.5055486,31.2435413 16.1200745,31.7181953 17.6437852,32.1374295 C19.1674959,32.5566637 20.3932148,32.6548591 21.7139396,32.6548591 C26.8164564,32.6548591 31.8618624,28.3188121 34.7358121,23.5764362 C29.1074396,22.9266846 23.7830336,22.2628893 18.5647349,20.4690503 C16.5293456,19.7690537 14.635953,19.4298221 12.7787617,19.4298221 C8.55943289,19.4298221 4.41812416,22.5000705 0.450332215,25.765057 C-0.362013423,26.4332215 -0.0174765101,27.7473926 1.01894295,27.9293356 L1.04453356,27.9340168 C3.41010403,28.3481477 5.37220916,28.3481477 7.8135604,29.2675369 C5.89506275,28.8287748 11.1699413,30.218848 12.837745,30.7311946 Z",
    id: "Path",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.2261208,3.30337248 C31.3491141,-1.45055034 22.1483557,-0.852291946 16.3452181,4.72240268 C13.058698,7.88003356 10.7761409,13.0215604 9.3449396,16.6148557 C8.84217785,17.8747248 8.7629094,18.7429329 8.75073826,19.4859966 C9.79549959,19.2689763 10.8597187,19.1593859 11.9267819,19.1589362 C13.9022517,19.1589362 15.906745,19.5156443 18.0547953,20.2493456 C23.412906,22.0831309 28.9382919,22.7147819 34.7854329,23.3848188 L34.7879295,23.3848188 L38.5382013,23.6968993 C41.0114396,23.8804027 43.7859885,24.2299329 46.065896,24.2299329 C47.1107416,14.0888758 44.7517248,7.81387248 38.2261208,3.30337248 Z M41.9342617,34.2218154 L8.22956376,0.51711745",
    id: "Shape"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYotiIconHeadwearLight);
export default __webpack_public_path__ + "static/media/Yoti_icon_headwear_light.bd319eec897d41f66b67f3e5a287eb0e.svg";
export { ForwardRef as ReactComponent };